"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDaySuffix = void 0;
const addDaySuffix = (day) => {
    const _day = typeof day === 'string' ? parseInt(day) : day;
    let suffix;
    switch (_day % 10) {
        case 1:
            suffix = _day === 11 ? 'th' : 'st';
            break;
        case 2:
            suffix = _day === 12 ? 'th' : 'nd';
            break;
        case 3:
            suffix = _day === 13 ? 'th' : 'rd';
            break;
        default:
            suffix = 'th';
            break;
    }
    return day + suffix;
};
exports.addDaySuffix = addDaySuffix;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkLWRheS1zdWZmaXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvYWRkLWRheS1zdWZmaXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sTUFBTSxZQUFZLEdBQUcsQ0FBQyxHQUFvQixFQUFFLEVBQUU7SUFDbkQsTUFBTSxJQUFJLEdBQUcsT0FBTyxHQUFHLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQztJQUUzRCxJQUFJLE1BQU0sQ0FBQztJQUVYLFFBQVEsSUFBSSxHQUFHLEVBQUUsRUFBRTtRQUNqQixLQUFLLENBQUM7WUFDSixNQUFNLEdBQUcsSUFBSSxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7WUFDbkMsTUFBTTtRQUNSLEtBQUssQ0FBQztZQUNKLE1BQU0sR0FBRyxJQUFJLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztZQUNuQyxNQUFNO1FBQ1IsS0FBSyxDQUFDO1lBQ0osTUFBTSxHQUFHLElBQUksS0FBSyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1lBQ25DLE1BQU07UUFDUjtZQUNFLE1BQU0sR0FBRyxJQUFJLENBQUM7WUFDZCxNQUFNO0tBQ1Q7SUFFRCxPQUFPLEdBQUcsR0FBRyxNQUFNLENBQUM7QUFDdEIsQ0FBQyxDQUFDO0FBckJXLFFBQUEsWUFBWSxnQkFxQnZCIn0=